const LS_KEY = 'entradas_pendientes';
const LS_SIN_EXISTENCIAS = 'entradas_sin_existencias';

class EntradasLocalService {
  static _nextId = 0;

  static _normTexto(v) {
    return String(v ?? "").trim().toUpperCase();
  }

  static _normMedida(v) {
    const n = Number(v);
    return Number.isFinite(n) ? String(n) : String(v ?? "").trim().toUpperCase();
  }

  static _mismaPartida(a, b) {
    return (
      this._normTexto(a.clavearticulo) === this._normTexto(b.clavearticulo) &&
      this._normMedida(a.medida) === this._normMedida(b.medida) &&
      this._normTexto(a.almacenexhibidor) === this._normTexto(b.almacenexhibidor)
    );
  }

  static _generarId() {
    this._nextId -= 1;
    return this._nextId;
  }

  static cargar() {
    try {
      const stored = localStorage.getItem(LS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  }

  static guardar(items) {
    try {
      localStorage.setItem(LS_KEY, JSON.stringify(items));
    } catch {}
  }

  static agregarArticulo(partida) {
    try {
      if (!partida) return null;
      const items = this.cargar();
      const existingIndex = items.findIndex((item) => this._mismaPartida(item, partida));

      if (existingIndex >= 0) {
        const existing = items[existingIndex];
        const cantidadSumada = (Number(existing.cantidadarticulo) || 0) + (Number(partida.cantidadarticulo) || 0);
        items[existingIndex] = { ...existing, cantidadarticulo: cantidadSumada };
      } else {
        const item = { ...partida };
        if (item.id === undefined || item.id === null) {
          item.id = this._generarId();
        }
        items.push(item);
      }

      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return items;
    } catch {
      return null;
    }
  }

  static actualizarCantidad(id, nuevaCantidad) {
    try {
      const items = this.cargar();
      const index = items.findIndex((item) => item.id === id || item._localId === id);
      if (index < 0) return false;
      items[index] = { ...items[index], cantidadarticulo: nuevaCantidad };
      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return true;
    } catch {
      return false;
    }
  }

  static eliminarPartida(id) {
    try {
      const items = this.cargar().filter((item) => item.id !== id && item._localId !== id);
      localStorage.setItem(LS_KEY, JSON.stringify(items));
      return items;
    } catch {
      return [];
    }
  }

  static limpiar() {
    try {
      localStorage.removeItem(LS_KEY);
    } catch {}
  }

  static limpiarSinExistencias() {
    try {
      localStorage.removeItem(LS_SIN_EXISTENCIAS);
    } catch {}
  }
}

export default EntradasLocalService;
